export const enforce = {
  notUndefined<Value>(value: Value | undefined, message?: string): Value {
    if (value === undefined) {
      throw new Error(message || "Value is undefined");
    }
    return value;
  },
};
